<template>
    <div style="background-color: #fafafa;">
        <van-nav-bar title="产品详情"  left-arrow @click-left="onClickLeft" @click-right="onClickRight" :right-text="rightText" fixed></van-nav-bar>
        <van-swipe style="margin-top: 45px;" :height="250" @change="setCurrentIndex">
            <van-swipe-item height="250" style="text-align: center;background-color: #fafafa;line-height: 250px;"
                            v-for="(image, index) in imageList" :key="index">
                <img
                        width="95%"
                        height="100%"
                        :src="image"
                />
            </van-swipe-item>
            <template #indicator="">
                <div class="custom-indicator">{{activeIndex}}/{{totalSize}}</div>
            </template>
        </van-swipe>
        <table class="layout" style="margin-bottom: 4rem">
            <tr>
                <td style="padding-left: 10px;margin-bottom: 10px;">
                    <p>
                        <span style="font-size: 15px; font-weight: bold">{{name}}</span><br/>
                        <span style="font-size: 13px;">代码:{{code}}</span><br/>
                        <span v-if="data.actualHeightId ==='1'" style="font-size: 13px;">定制中心距:{{data.centerSpacing}}</span>
                        <span v-if="isSpecials !== ''" style="font-size: 13px;">定制进水方式:{{isSpecials}}</span>
                    </p>
                    <p style="padding-right: 20px;">
                        <span style="font-size: 16px; font-weight: bold; color: #ff3300; float: right;">¥{{data.price}}</span>
                    </p>
                    <van-field label=""  readonly v-model="skuInfo" right-icon="arrow"
                               @click-right-icon="chooseSkuDetail" placeholder="选择产品" type="textarea" />
                    <van-field placeholder="请填写" label-width="15rem" v-model="data.pieces" type="digit" :readonly="piecesReadonly" label="填写柱数(1~)" />
                    <van-field placeholder="请填写" label-width="15rem" v-model="data.quantity" type="digit" label="填写暖气组数" />
                    <van-field label="备注"  v-model="mainRemark"
                               placeholder="给厂家备注..." type="textarea" autosize/>
                </td>
            </tr>
        </table>
        <van-popup v-model="showDetails" closeable position="bottom" :style="{ height: '80%' }"
                   :close-on-click-overlay="false" @click-close-icon="closeChosenPop()">
            <table class="layout">
                <tr style="margin-left: 10px;margin-right: 10px;">
                    <td style="width: 80px;">
                        <van-image
                                width="80"
                                height="80"
                                :src="imageList[0]"
                        />
                    </td>
                    <td style="padding-left: 10px;">
                        <p>
                            <span style="font-size: 16px; font-weight: bold; color: #ff3300">¥{{tempData.price}}</span>
                        </p>
                        <p>
                            <span style="font-size: 15px; font-weight: bold">{{name}}</span>
                        </p>
                        <p>
                            <span style="font-size: 12px; color: grey;">{{detailTitle}}</span>
                            <span style="font-size: 12px; color: grey;">{{tempSkuInfo}}</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <van-field-acb v-model="tempData.heightId" dict="v_center_spacing" label="中心距" :filter="heightFilter" :on-change="setSkuInfo()"></van-field-acb>
                        <van-field  v-if="tempData.heightId==='1'" v-model="tempData.centerSpacing" type="text" label="特殊中心距" @blur="setSkuInfo()"/>
                        <van-field-acb v-model="tempData.caliber" dict="dict_rad_caliber" label="接口口径" :filter="caliberFilter" :on-change="setSkuInfo()"></van-field-acb>
                        <van-field-acb v-if="categoryType!=='5'" v-model="tempData.waterFlow" dict="dict_rad_flowin_method" label="进水方式" :filter="waterFilter" :on-change="setSkuInfo()"></van-field-acb>
                        <van-field-acb v-model="tempData.color" dict="dict_rad_color" label="颜色" :filter="colorFilter" :on-change="setSkuInfo()"></van-field-acb>
                        <van-field v-if="tempData.waterFlow==='5f5d42926a37438484714d1d706780ba'" v-model="isSpecials" type="textarea" placeholder="如需定制特殊进水方式，请备注..." autosize/>
                        <van-button :disabled="!(tempData.heightId&&tempData.heightId!=='0'&&tempData.caliber&&tempData.color&&(tempData.waterFlow || categoryType==='5'))" type="warning" size="large" @click="setSkuDetails()">确定</van-button>
                    </td>
                </tr>
            </table>
        </van-popup>
        <van-popup v-model="showCustomerInfo" closeable position="bottom" :style="{ height: '30%' }"
                   :close-on-click-overlay="false" >
            <table class="layout">
                <tr>
                    <td colspan="2">
                        <van-field  v-model="customerName" type="text" placeholder="用户名称"/>
                        <van-field  v-model="arrivalAddress" type="text" placeholder="安装地址"/>
                        <van-field  v-model="arrivalMobile" type="text" placeholder="联系方式"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <van-button type="default" size="large" @click="cancelSettleOrder()">取消</van-button>
                    </td>
                    <td>
                        <van-button type="danger" size="large" @click="getIntoOrder()">确定</van-button>
                    </td>
                </tr>
            </table>
        </van-popup>
        <div class="recordBox" v-if="!uuid">
            <table style="width: 100%;margin-bottom: 3px;border-spacing:0;">
                <tr style="height:35px;padding: 0;">
                    <td style="width: 50%;background-color:#ff976a;">
                        <van-button type="warning" native-type="button" size="large" @click="saveCartInfo()">加入购物车</van-button>
                    </td>
                    <td style="width: 50%;background-color:#ee0a24;" >
                        <van-button type="danger" native-type="button" size="large" @click="confirmOrder()">立即购买</van-button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import {Tab, Tabs, Panel, Field, Image, List,Search, Popup, PullRefresh, NavBar, Button,Toast,Swipe, SwipeItem } from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import VanFieldAcb from '../../components/VanFieldAcb';
    import {API_URL} from "../../common/config";
    import Vue from "vue";

    export default {
        data: function () {
            return {
                uuid: "",
                radId: "",
                radCategory: "",
                categoryType: "",
                groupId: "",
                name: "",
                code: "",
                data: {},
                tempData: {},
                skuInfo: "",
                tempSkuInfo: "",
                imageList: [],
                activeIndex: 1,
                totalSize: 1,
                descriptions: [],
                heightFilter: "",
                colorFilter: "",
                caliberFilter: "",
                waterFilter: "",
                type: 0,
                requiredValidation: false,
                imageUrl: API_URL + "/oa/common/attachment/showImage?id=",
                showDetails: false,
                detailTitle: "请选择:",
                rightText: "",
                mainRemark: "",
                isSpecials: "",
                showCustomerInfo: false,
                customerName: "",
                arrivalAddress: "",
                arrivalMobile: "",
                minPieces: 0,
                maxPieces: 0,
                piecesReadonly: true,
                editType: ""
            }
        },
        components: {
            VanFieldAcb,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [Image.name]: Image,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [PullRefresh.name]: PullRefresh
        },
        created: async function () {
            this.uuid = this.$route.query.uuid || "";
            if(this.uuid){
                this.rightText = "保存";
            }
            this.data.price = parseFloat("0");
            this.data.unitedPrice = parseFloat("0");
            this.data.skuInfo = "";
            this.radId = this.$route.query.radId;
            this.groupId = this.$route.query.groupId;
            this.editType = this.$route.query.editType || "";
            let resp = await dealerOrderService.getRadSkuById(this.radId, this.groupId, "");
            if (resp.data.Status === "1" && resp.data.Data){
                (resp.data.Data.imageIds || "8b6e3f6ee76747e89875a1d3bc4b7fff").split(",").forEach(item => {
                    this.imageList.push(this.imageUrl + item);
                });

                this.name = resp.data.Data.name;
                this.code = resp.data.Data.code;
                this.minPieces = resp.data.Data.minPieces || 0;
                this.maxPieces = resp.data.Data.maxPieces || 0;
                this.radCategory = resp.data.Data.categoryId;
                this.categoryType = resp.data.Data.categoryType;
                this.totalSize = this.imageList.length;
                if(resp.data.Data.categoryType === "5" || resp.data.Data.categoryType === "3a358e87230949a58d29fc796be692ce"){
                    this.data.pieces = 1;
                    this.piecesReadonly = true;
                }
            }
            if(this.uuid){
                resp = await dealerOrderService.getCartInfoById(this.uuid, this.$route.query.editType || "");
                if (resp.data.Status === "1" && resp.data.Data){
                    /*this.data.skuInfo = resp.data.Data.skuInfo;
                    this.data.tempSkuInfo = resp.data.Data.tempSkuInfo;
                    this.data.unitedPrice = resp.data.Data.unitedPrice;
                    this.data.price = resp.data.Data.price;
                    this.data.heightId = resp.data.Data.heightId;
                    this.data.actualHeightId = resp.data.Data.actualHeightId;
                    this.data.centerSpacing = resp.data.Data.centerSpacing;
                    this.data.color = resp.data.Data.color;
                    this.data.waterFlow = resp.data.Data.waterFlow;
                    this.data.caliber = resp.data.Data.caliber;
                    this.data.pieces = resp.data.Data.pieces;
                    this.data.quantity = resp.data.Data.quantity;
                    ;*/
                    this.mainRemark = resp.data.Data.mainRemark || ""
                    Vue.set(this.data, "tempSkuInfo", resp.data.Data.tempSkuInfo);
                    Vue.set(this.data, "unitedPrice", resp.data.Data.unitedPrice);
                    Vue.set(this.data, "price", resp.data.Data.price);
                    Vue.set(this.data, "settlePrice", resp.data.Data.settlePrice);
                    Vue.set(this.data, "settleUnitedPrice", resp.data.Data.settleUnitedPrice);
                    Vue.set(this.data, "heightId", resp.data.Data.heightId);
                    Vue.set(this.data, "actualHeightId", resp.data.Data.actualHeightId);
                    Vue.set(this.data, "centerSpacing", resp.data.Data.centerSpacing);
                    Vue.set(this.data, "color", resp.data.Data.color);
                    Vue.set(this.data, "waterFlow", resp.data.Data.waterFlow);
                    Vue.set(this.data, "caliber", resp.data.Data.caliber);
                    Vue.set(this.data, "pieces", resp.data.Data.pieces);
                    Vue.set(this.data, "quantity", resp.data.Data.quantity);
                    Vue.set(this.data, "skuInfo", resp.data.Data.skuInfo);
                    this.skuInfo = resp.data.Data.skuInfo;
                    this.isSpecials = resp.data.Data.isSpecials;
                }
            }

            let filterResp = await dealerOrderService.getRadSkuDictFilterById(this.radId);
            if (filterResp.data.Status === "1" && filterResp.data.Data){
                this.heightFilter = filterResp.data.Data.heightFilter || "";
                this.colorFilter = filterResp.data.Data.colorFilter || "";
                this.caliberFilter = filterResp.data.Data.caliberFilter || "";
                this.waterFilter = filterResp.data.Data.waterFilter || "";
            }
        },
        methods: {
            async setSkuInfo(){
                if(!this.showDetails){
                    return;
                }
                if(!this.tempData.waterFlow || this.tempData.waterFlow !== "5f5d42926a37438484714d1d706780ba"){
                    this.isSpecials = "";
                }
                let isEmpty = (!this.tempData.heightId || this.tempData.heightId==='0')
                      &&!this.tempData.caliber&&!this.tempData.color&&!this.tempData.waterFlow;
                if(isEmpty){
                    this.detailTitle = "请选择:"
                    return;
                }
                this.detailTitle = "已选:"
                let resp = await dealerOrderService.getRadSkuInfoByParam(this.tempData.heightId, this.tempData.centerSpacing,
                                                this.tempData.color, this.tempData.waterFlow, this.tempData.caliber, this.groupId, this.radId);
                if (resp.data.Status === "1" && resp.data.Data){
                     this.tempData.skuInfo = resp.data.Data.skuInfo;
                     this.tempData.tempSkuInfo = resp.data.Data.tempSkuInfo;
                     this.tempData.price = resp.data.Data.price;
                     this.tempData.settlePrice = resp.data.Data.settlePrice;
                     this.tempData.unitedPrice = 0;
                     this.tempData.settleUnitedPrice = 0;
                     this.tempData.actualHeightId = resp.data.Data.heightId;
                     this.tempData.actualCenterSpacing = resp.data.Data.centerSpacing;
                     this.tempSkuInfo = resp.data.Data.tempSkuInfo;
                }
            },
            async setSkuDetails(){
                if(this.tempData.heightId==='1' && this.tempData.centerSpacing){
                    if(parseFloat(this.tempData.centerSpacing) < 200 || parseFloat(this.tempData.centerSpacing) > 1800){
                        Toast.clear();
                        Toast.fail( "特殊中心距必须在200-1800之间，请检查！");
                        return;
                    }
                }
                this.showDetails = false;
                this.data.skuInfo = this.tempData.skuInfo;
                this.data.tempSkuInfo = this.tempData.tempSkuInfo;
                this.data.unitedPrice = this.tempData.unitedPrice;
                this.data.settleUnitedPrice = this.tempData.settleUnitedPrice;
                this.data.price = this.tempData.price;
                this.data.settlePrice = this.tempData.settlePrice;
                this.data.heightId = this.tempData.actualHeightId;
                this.data.actualHeightId = this.tempData.heightId;
                this.data.centerSpacing = this.tempData.actualCenterSpacing;
                this.data.color = this.tempData.color;
                this.data.waterFlow = this.tempData.waterFlow;
                this.data.caliber = this.tempData.caliber;
                this.skuInfo = this.tempData.skuInfo;
                let resp = await dealerOrderService.getRadSkuById(this.radId, this.groupId, this.tempData.actualHeightId);
                if (resp.data.Status === "1" && resp.data.Data){
                    this.minPieces = resp.data.Data.minPieces || 0;
                    this.maxPieces = resp.data.Data.maxPieces || 0;
                }
                if(this.categoryType !== "5" && this.categoryType !== "3a358e87230949a58d29fc796be692ce"){
                    this.piecesReadonly = false;
                }
            },
            chooseSkuDetail(){
                this.showDetails = true;
                this.tempData.price = this.data.price;
                if(this.data.heightId){
                    Vue.set(this.tempData, "skuInfo", this.data.skuInfo);
                    Vue.set(this.tempData, "tempSkuInfo", this.data.tempSkuInfo);
                    Vue.set(this.tempData, "unitedPrice", this.data.unitedPrice);
                    Vue.set(this.tempData, "price", this.data.price);
                    Vue.set(this.tempData, "settlePrice", this.data.settlePrice);
                    Vue.set(this.tempData, "settleUnitedPrice", this.data.settleUnitedPrice);
                    Vue.set(this.tempData, "heightId", this.data.actualHeightId);
                    Vue.set(this.tempData, "actualHeightId", this.data.heightId);
                    Vue.set(this.tempData, "centerSpacing", this.data.centerSpacing);
                    Vue.set(this.tempData, "actualCenterSpacing", this.data.centerSpacing);
                    Vue.set(this.tempData, "color", this.data.color);
                    Vue.set(this.tempData, "waterFlow", this.data.waterFlow);
                    Vue.set(this.tempData, "caliber", this.data.caliber);
                    this.tempSkuInfo = this.data.tempSkuInfo;
                }
            },
            closeChosenPop(){
                this.showDetails = false;
            },
            setCurrentIndex(index){
                this.activeIndex = index + 1;
            },
            async saveCartInfo(){
                Toast.loading({
                    duration:0,
                    message: '保存中...',
                    forbidClick: true,
                });
                if(parseInt((this.data.pieces || "0") + "") <= 0){
                    Toast.clear();
                    Toast.fail( "柱数未填写！");
                    return;
                }
                if(this.minPieces > 0 && parseInt((this.data.pieces || "0") + "") < this.minPieces){
                    Toast.clear();
                    Toast.fail( "柱数不得小于"+ this.minPieces +"！");
                    return;
                }
                if(this.maxPieces > 0 && parseInt((this.data.pieces || "0") + "") > this.maxPieces){
                    Toast.clear();
                    Toast.fail( "柱数不得大于"+ this.maxPieces +"！");
                    return;
                }
                if(parseInt((this.data.quantity || "0") + "") <= 0){
                    Toast.clear();
                    Toast.fail( "数量必须大于0！");
                    return;
                }

                if(!this.data.centerSpacing){
                    Toast.clear();
                    Toast.fail("请选择中心距！");
                    return;
                }
                if(!this.data.caliber){
                    Toast.clear();
                    Toast.fail("接口口径未选择！");
                    return;
                }
                if(!this.data.color){
                    Toast.clear();
                    Toast.fail("颜色未选择！");
                    return;
                }
                if(this.categoryType !== "5" && !this.data.waterFlow){
                    Toast.clear();
                    Toast.fail("进水方式未选择！");
                    return;
                }

                this.data.unitedPrice = parseFloat((parseInt(this.data.pieces+"")*parseFloat(this.data.price)).toFixed(2));
                this.data.settleUnitedPrice = parseFloat((parseInt(this.data.pieces+"")*parseFloat(this.data.settlePrice)).toFixed(2));
                let resp = await dealerOrderService.saveSkuInfo({
                    uuid: this.uuid || "",
                    radCategory: this.radCategory,
                    radId: this.radId,
                    heightId: this.data.heightId,
                    centerSpacing: this.data.centerSpacing,
                    caliber: this.data.caliber,
                    color: this.data.color,
                    waterFlow: this.data.waterFlow,
                    pieces: this.data.pieces,
                    price: this.data.price,
                    settlePrice: this.data.settlePrice,
                    unitedPrice: this.data.unitedPrice,
                    settleUnitedPrice: this.data.settleUnitedPrice,
                    quantity: this.data.quantity,
                    mainRemark: this.mainRemark,
                    isSpecials: this.isSpecials,
                    extraAmount: this.data.waterFlow === "5f5d42926a37438484714d1d706780ba" ? parseFloat("30") :  parseFloat("0"),
                    type: "main",
                    editType: this.editType
                });
                if (resp.data.Status === "1"){
                    Toast.clear();
                    Toast.success('保存成功！');
                    if(this.editType === "order"){
                        this.$router.push("/rad/radOrder");
                    }else{
                        this.$router.push("radCart");
                    }
                } else {
                    Toast.clear();
                    Toast.fail(resp.data.Message);
                }
            },
            async confirmOrder(){
                if(parseInt((this.data.pieces || "0") + "") <= 0){
                    Toast.clear();
                    Toast.fail( "柱数未填写！");
                    return;
                }
                if(this.minPieces > 0 && parseInt((this.data.pieces || "0") + "") < this.minPieces){
                    Toast.clear();
                    Toast.fail( "柱数不得小于"+ this.minPieces +"！");
                    return;
                }
                if(this.maxPieces > 0 && parseInt((this.data.pieces || "0") + "") > this.maxPieces){
                    Toast.clear();
                    Toast.fail( "柱数不得大于"+ this.maxPieces +"！");
                    return;
                }
                if(parseInt((this.data.quantity || "0") + "") <= 0){
                    Toast.clear();
                    Toast.fail( "数量必须大于0！");
                    return;
                }

                if(!this.data.centerSpacing){
                    Toast.clear();
                    Toast.fail("请选择中心距！");
                    return;
                }
                if(!this.data.caliber){
                    Toast.clear();
                    Toast.fail("接口口径未选择！");
                    return;
                }
                if(!this.data.color){
                    Toast.clear();
                    Toast.fail("颜色未选择！");
                    return;
                }
                if(this.categoryType !== "5" && !this.data.waterFlow){
                    Toast.clear();
                    Toast.fail("进水方式未选择！");
                    return;
                }
                this.data.unitedPrice = parseFloat((parseInt(this.data.pieces+"")*parseFloat(this.data.price)).toFixed(2));
                this.data.settleUnitedPrice = parseFloat((parseInt(this.data.pieces+"")*parseFloat(this.data.settlePrice)).toFixed(2));
                this.showCustomerInfo = true;
            },
            cancelSettleOrder(){
                this.showCustomerInfo = false;
                this.customerName = "";
                this.arrivalAddress = "";
                this.arrivalMobile = "";
            },
            async getIntoOrder(){
                Toast.loading({
                    duration:0,
                    message: '处理中...',
                    forbidClick: true,
                });
                let cartResp = await dealerOrderService.saveSkuInfo({
                    uuid: this.uuid || "",
                    radCategory: this.radCategory,
                    radId: this.radId,
                    heightId: this.data.heightId,
                    centerSpacing: this.data.centerSpacing,
                    caliber: this.data.caliber,
                    color: this.data.color,
                    waterFlow: this.data.waterFlow,
                    pieces: this.data.pieces,
                    price: this.data.price,
                    settlePrice: this.data.settlePrice,
                    unitedPrice: this.data.unitedPrice,
                    settleUnitedPrice: this.data.settleUnitedPrice,
                    quantity: this.data.quantity,
                    mainRemark: this.mainRemark,
                    isSpecials: this.isSpecials,
                    extraAmount: this.data.waterFlow === "5f5d42926a37438484714d1d706780ba" ? parseFloat("30") :  parseFloat("0"),
                    type: "main"
                });
                if (cartResp.data.Status === "1"){
                    const cartId = cartResp.data.Data;
                    let resp = await dealerOrderService.settleSkuOrder(this.customerName, this.arrivalAddress, this.arrivalMobile, cartId);
                    if (resp.data.Status === "1"){
                        Toast.clear();
                        this.showCustomerInfo = false;
                        this.$router.push("radOrder");
                    } else {
                        Toast.clear();
                        Toast.fail(resp.data.Message);
                        this.showCustomerInfo = false;
                    }
                } else {
                    Toast.clear();
                    Toast.fail(cartResp.data.Message);
                    this.showCustomerInfo = false;
                }
            },
            onClickRight(){
                if(this.uuid){
                    this.saveCartInfo();
                }
            },
            onClickLeft(){
                this.$router.go(-1);
            }
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 0;
    }
    .layout p {
        margin: 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .recordBox {
        padding: 0.5rem 0;
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:0;
        position:fixed;
        width: 100%;
    }
    .custom-indicator {
        width: 40px;
        position: absolute;
        right: 45%;
        bottom: 5px;
        padding: 10px 20px;
        font-weight: bold;
        color: white;
        font-size: 12px;
        background: dimgrey;
        border-radius: 40%;
    }
    .skuDetailDiv{
        width:100%;
        margin:0 auto;
        overflow: hidden;
        padding-bottom: 150px;
    }
</style>